import { render } from "./SnapshotName.vue?vue&type=template&id=5c535c21"
import script from "./SnapshotName.vue?vue&type=script&lang=js"
export * from "./SnapshotName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__